import Time from 'model/appointments/timeSlots/time'
import { isNil } from 'ramda'
import { CONFIRMED } from 'constants/appointments'

class Confirmed extends Time {
  constructor(init) {
    super(init)
    // console.log('> Confirmed constructor -', init)
    if (isNil(init)) return undefined
  }

  // Calculable
  get isConfirmed() {
    return this.__typename === CONFIRMED
  }
}

export default Confirmed
